import { CountyDropDown, DropDownBoxLayoutStyle } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const CountyField = () => {
    const value = useWizardDemoStore((state) => state.property.county);
    // State abbreviation; the county list is filtered to this state
    const selectedState = useWizardDemoStore((state) => state.property.state);
    const updateProperty = useWizardDemoStore((state) => state.updateProperty);

    return (
        <CountyDropDown
            id='propertyCounty'
            value={value}
            selectedState={selectedState}
            onChange={(county) => updateProperty({ county: county ?? '' })}
            label='County'
            required={true}
            width={'100%'}
            placeholder={selectedState ? 'Select' : 'Select a State First'}
            readOnly={!selectedState}
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            height='36px'
        />
    );
};
